import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {AccrualTemplate, AccrualTemplateSearchParams} from '@accounting/_common/models/accrual-template.models';

export const CheckState = createAction(
    '[AccrualTemplates] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: AccrualTemplate[] } }>()
);

export const CheckStateSuccess = createAction(
    '[AccrualTemplates] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: AccrualTemplate[] } }>()
);

export const LoadList = createAction(
    '[AccrualTemplates] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[AccrualTemplates] Load List Success',
    props<{ payload: { items: AccrualTemplate[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[AccrualTemplates] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[AccrualTemplates] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[AccrualTemplates] Set Filter',
    props<{ payload: AccrualTemplateSearchParams }>()
);

export const SetLoading = createAction(
    '[AccrualTemplates] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[AccrualTemplates] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[AccrualTemplates] Update Item Success',
    props<{ payload: AccrualTemplate }>()
);

export const DeleteItem = createAction(
    '[AccrualTemplates] Delete Item',
    props<{ payload: AccrualTemplate }>()
);

export const DeleteItemSuccess = createAction(
    '[AccrualTemplates] Delete Item Success',
    props<{ payload: AccrualTemplate }>()
);

export const DeleteItemFailure = createAction(
    '[AccrualTemplates] Delete Item Failure',
    props<{ payload: AccrualTemplate }>()
);

export const SetInitialState = createAction(
    '[AccrualTemplates] Set Initial State'
);
